import { Close as CloseIcon, TaskRounded } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { resetInspectionSelectedFilters, setInspectionSelectedFilters } from 'app/actions/checklist';
import { Scrollbar } from 'app/components';
import { ChecklistInspectionFilterForm } from 'app/pages/Checklist';
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const ChecklistInspectionFilterDialog = ({ open, onClose }) => {
    const formRef = useRef(null);
    const dispatch = useDispatch();
    const { inspectionSelectedFilters } = useSelector((state) => state.checklist);
    const handleFormClick = () => {
        var _a;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.handleFormSubmit();
        onClose();
    };
    const handleResetClick = () => {
        dispatch(resetInspectionSelectedFilters());
    };
    const handleFormSubmit = (params) => dispatch(setInspectionSelectedFilters(params));
    return (React.createElement(Dialog, { maxWidth: 'md', fullWidth: true, open: open, onClose: onClose, sx: (theme) => ({
            width: '100%',
            height: '100%',
            '.MuiDialog-paper': {
                minWidth: '540px',
            },
            '.MuiDialogTitle-root': {
                display: 'flex',
                padding: theme.spacing(2),
                alignItems: 'center',
            },
            '.MuiDialogTitle-root .MuiTypography-root': {
                marginLeft: theme.spacing(1.5),
            },
            '.MuiDialogTitle-root .MuiButtonBase-root': {
                marginLeft: 'auto',
            },
            '.MuiDialogContent-root': {
                padding: theme.spacing(0),
            },
            '.MuiDialogContent-root .simplebar-container': {
                padding: theme.spacing(0, 2),
            },
            '.MuiDialogActions-root': {
                padding: theme.spacing(2),
                justifyContent: 'flex-end',
            },
            '.MuiAvatar-circular': {
                bgcolor: alpha(theme.palette.primary.main, 0.12),
                svg: {
                    width: '16px',
                    height: '16px',
                },
                path: {
                    fill: theme.palette.primary.main,
                },
            },
            '.MuiAlert-root': {
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(2),
                borderRadius: theme.shape.borderRadius,
            },
        }) },
        React.createElement(DialogTitle, null,
            React.createElement(Avatar, null,
                React.createElement(TaskRounded, { fontSize: 'small' })),
            React.createElement(Typography, { component: 'p' }, "\u0424\u0438\u043B\u044C\u0442\u0440\u044B \u043F\u043E \u043E\u0441\u043C\u043E\u0442\u0440\u0430\u043C"),
            React.createElement(IconButton, { color: 'default', onClick: onClose },
                React.createElement(CloseIcon, { fontSize: 'small' }))),
        React.createElement(DialogContent, null,
            React.createElement(Scrollbar, null,
                React.createElement(ChecklistInspectionFilterForm, { ref: formRef, defaultValues: inspectionSelectedFilters, onSubmit: handleFormSubmit }))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: handleResetClick, disableElevation: true }, "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0424\u0438\u043B\u044C\u0442\u0440\u044B"),
            React.createElement(LoadingButton, { variant: 'contained', onClick: handleFormClick, disableElevation: true }, "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C"))));
};
export default ChecklistInspectionFilterDialog;
